import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3>同步到家</h3>
            <p>
              买装修材料，找装修师傅，就到同步到家<br />
              专为装修需求打造的多商户一站式装修服务商城。这里汇聚优质装修公司、品牌建材商、资深装修师傅,覆盖装修全流程需求,让你省心装新家!
            </p>
          </div>

          <div className="footer-section">
            <h3>联系电话：</h3>
            <div className="footer-contact">
              <span>📞 18070478121</span>
            </div>
            <br />
             <h3>公司地址：</h3>
            <div className="footer-contact">
              <span>📍 江西省赣州市章贡区同步到家(章贡区中心仓建材一站式集中配送中心)</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 赣州赣晋贸易有限公司.版权所有</p>
          <div className="footer-beian">
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo"
              target="_blank"
              rel="noopener noreferrer"
              className="beian-item"
            >
              <img
                src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png"
                alt="公安备案"
                className="beian-icon"
              />
              赣公网安备36070202001216号
            </a>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="beian-item"
            >
              赣ICP备2025076752号
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;